<template>
    <CardPage :section="18" :page="5" next="/" nextLabel="Finish" :nextFunction="finish" :audio="true">
        <p>
            Fantastic job! You’ve earned another sticker for completing this activity!
        </p>
        <ResponsiveImage :src="sticker.image" :alt="sticker.text"></ResponsiveImage>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    computed: {
        sticker: get('section18/sticker')
    },
    methods: {
        finish() {
            this.$store.set('section18/complete', true);
            this.$store.set('section18/sticker@earned', true);
        }
    }
};
</script>
